export interface VisualViewportSize {
    offsetTop: number
    height: number
}

export interface PanelViewportBox {
    top: number
    height: number
}

/**
 * Where a fixed full-screen panel should sit while the visible area is shorter than the
 * layout viewport. A software keyboard does that on iOS, and `position: fixed; bottom: 0`
 * stays on the layout viewport underneath it. A difference of a pixel or less is left to CSS.
 */
export const panelBoxForVisualViewport = (
    layoutHeight: number,
    visual: VisualViewportSize | null,
): PanelViewportBox | null => {
    if (visual === null || layoutHeight <= 0 || visual.height <= 0) {
        return null
    }

    const covered = layoutHeight - visual.offsetTop - visual.height

    if (covered <= 1) {
        return null
    }

    return {
        top: Math.max(0, visual.offsetTop),
        height: visual.height,
    }
}

export const applyPanelViewport = (
    panel: HTMLElement,
    layoutHeight: number,
    visual: VisualViewportSize | null,
): void => {
    const box = panelBoxForVisualViewport(layoutHeight, visual)

    if (box === null) {
        panel.style.top = ''
        panel.style.height = ''
        panel.style.bottom = ''

        return
    }

    panel.style.top = `${box.top}px`
    panel.style.height = `${box.height}px`
    panel.style.bottom = 'auto'
}
